import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./components/App";
// import registerServiceWorker from "./registerServiceWorker";
import rootSaga from "./sagas";
import configureStore from "./config/store";
import configFonts from "./config/fonts";
import configFontAwesome from "./config/fontAwesome";

import "./app.css";

configFonts();
configFontAwesome();

const store = configureStore();
store.runSaga(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Routes>
        <Route path="/jobs/:id" element={<App />} />
        <Route path="/" element={<App />} />
      </Routes>
    </Router>
  </Provider>,
  document.getElementById("root")
);
// registerServiceWorker();
